var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtn)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.exportar()}}},[_c('i',{staticClass:"fa fa-file-pdf-o mr-2"}),_vm._v(" Exportar ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }